import { Irrigator } from './Irrigator'

const typeName = 'SVCx'

export class SVCx extends Irrigator {
  constructor(ob: any) {
    super(ob)
    this.type = typeName
  }
}
